import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import './OrderConfirmDialog.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import API from '../lib/API';
import firebase from '../lib/Firebase';
import AlertDialog from './AlertDialog';

class OrderConfirmDialog extends React.Component {
  state = {
    loading: false,
    opened: false,

    message:'',
    status: '',

    canSave: false,

    showPreviewSaveAlert: false,
    showSaveErrorAlert: false
  }

  defaultData = {
    message:'',
    status: 'noCheck',
    timestamp: '',
    last_username: ''
  }

  componentDidMount = () => {
    this.setState({
      loading: '読み込み中',
      opened: false,
      message: '',
      status : '',
    });
    API.getOrderConfirm(this.props.albumCode)
      .then(orderConfirm => {
        if (orderConfirm) {
          this.defaultData = orderConfirm;
          if (['corrected', 'confirmed'].indexOf(orderConfirm.status) >= 0) {
            this.props.close(false);
            return;
          }
        }
        this.setState({
          loading: false,
          opened: true,
          message: orderConfirm ? orderConfirm.message : '',
          status : orderConfirm ? orderConfirm.status : 'noCheck'
        });
        this.messageArea.focus();
      })
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props.albumCode !== prevProps.albumCode) {
      
    }
  }

  handleClose = () => {
    this.props.close(false);
  }

  handleSave = () => {
    if (!this.state.canSave) return;
    if (this.state.status === 'confirmed') {
      this.setState({showPreviewSaveAlert:true});
    }
    else {
      this.save();
    }
  }
  save = () => {
    this.setState({loading: '保存中'});
    API.saveOrderConfirm(this.props.albumCode, {
      message:this.state.message,
      status: this.state.status,
      last_username: firebase.auth().currentUser.displayName
    }).then(saved => {
      if (saved) {
        this.setState({loading: false});
        this.props.close(true);
      }
      else {
        this.setState({loading: false, showSaveErrorAlert:true});
      }
    }).catch(e=>{
      this.setState({loading: false});
    })
  }

  handleChangeMessage = (e) => {
    this.setState({
      message: e.target.value,
      status: 'correct',
    }, this.checkChange);
  }
  handleChangeStatus = (e) => {
    if (e.target.value === 'corrected') return;
    this.setState({status: e.target.value}, this.checkChange)
  }
  checkChange = () => {
    if (this.defaultData.message === this.state.message && this.defaultData.status === this.state.status && this.state.canSave === true) {
      this.setState({canSave: false});
    }
    else if (this.state.canSave === false) {
      this.setState({canSave: true});
    }
  }

  handleClosePreviewSaveAlert = (doSave) => {
    if (doSave) {
      this.save();
    }
    this.setState({showPreviewSaveAlert:false})
  }
  handleCloseSaveErrorAler = () => {
    this.setState({showSaveErrorAlert:false});
  }

  render() {
    return(
      <LoadingOverlay active={!!this.state.loading} spinner text={this.state.loading} className="OrderConfirmDialog-loading">
        <div className="OrderConfirmDialog">
          <form className="OrderConfirmDialog-Window" ref={ref=>{this.form=ref;}} style={{display:(this.state.opened?'block':'none')}}>
              <div className="OrderConfirmDialog-Title">{this.props.name}</div>
              <textarea className="OrderConfirmDialog-Message" value={this.state.message} name="message" onChange={this.handleChangeMessage} ref={ref=>{this.messageArea=ref;}}></textarea>
              <div className="OrderConfirmDialog-Status">
                <label><input type="radio" name="status" value="noCheck" checked={this.state.status === 'noCheck'} onChange={this.handleChangeStatus}/><span><FontAwesomeIcon icon={faCheckCircle} />未確認</span></label>
                <label><input type="radio" name="status" value="correct" checked={this.state.status === 'correct'} onChange={this.handleChangeStatus}/><span><FontAwesomeIcon icon={faCheckCircle} />訂正有</span></label>
                {/*
                <label style={{cursor:'not-allowed', pointerEvents:'none'}}><input type="radio" name="status" value="correcting" checked={this.state.status === 'correcting'} onChange={this.handleChangeStatus} readOnly={true}/><span><FontAwesomeIcon icon={faCheckCircle} />訂正作業中</span></label>
                */}
                <label style={{cursor:'not-allowed', pointerEvents:'none'}}><input type="radio" name="status" value="corrected" checked={this.state.status === 'corrected'} onChange={this.handleChangeStatus} readOnly={true}/><span><FontAwesomeIcon icon={faCheckCircle} />訂正済</span></label>
                <label><input type="radio" name="status" value="confirmed"  checked={this.state.status === 'confirmed'} onChange={this.handleChangeStatus}/><span><FontAwesomeIcon icon={faCheckCircle} />確認済</span></label>
              </div>
              {
                this.defaultData.timestamp !== ''
                ? (<div className="OrderConfirmDialog-Props">
                  <div>最終保存：</div>
                  <div className="OrderConfirmDialog-Timestamp">{this.defaultData.timestamp}</div>
                  <div className="OrderConfirmDialog-LastUsername">{this.defaultData.orderConfirm && this.defaultData.orderConfirm.last_username ? `${this.defaultData.last_username} 様` : ''}</div>
                </div>)
                : null
              }
              <div className="OrderConfirmDialog-Buttons">
                <div className="OrderConfirmDialog-CancelBtn" onClick={this.handleClose}>キャンセル</div>
                <div className="OrderConfirmDialog-OkBtn" onClick={this.handleSave} data-enable={this.state.canSave}>保存</div>
              </div>
          </form>

        {
          this.state.showPreviewSaveAlert
          ? <AlertDialog okButtonName="[確認済]で保存" close={this.handleClosePreviewSaveAlert}>
            <p>[確認済]で保存すると再編集はできなくなります。</p>
            <p>訂正が必要な場合は弊社までご連絡ください。</p>
          </AlertDialog>
          : null
        }

        {
          this.state.showSaveErrorAlert
          ? <AlertDialog okButtonOnly={true} close={this.handleCloseSaveErrorAler}>
            <p>保存に失敗しました。</p>
          </AlertDialog>
          : null
        }

        </div>
      </LoadingOverlay>
    )
  }
}

export default OrderConfirmDialog;